import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=cbefb1a0&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbefb1a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbefb1a0')) {
      api.createRecord('cbefb1a0', component.options)
    } else {
      api.reload('cbefb1a0', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=cbefb1a0&scoped=true&", function () {
      api.rerender('cbefb1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SqYtVAP1mkdl/JS/comp/Accordion.vue"
export default component.exports